import React from "react";
import Images from "../../../assets/images/index";
import { useNavigate } from "react-router-dom";
export default function ConnectionError(props) {
    const navigate = useNavigate();
    const navigatePathName ='/' + props.pathName.split('/')[1]
    const navigateUrl = () => {
        navigate(navigatePathName)
    }
    return(
        <div className="no_data_found_wrapper something_went_wrong text-center mt-4">
            <img src={Images.NoDataImg} alt="No Data" className="img-fluid"/>
            <div className="no_data_text">
                <h4>No connection</h4>
                <p>Please click your internet connection</p>
            </div>
            <div className="retry_btn">
                <button type="button" onClick={navigateUrl} className="btn btn_theme">Retry Now</button>
            </div>
        </div>
    )
}